export const UserTypes =
{
  Anonymous: 1,
}

export default UserTypes;
